import React,{ Component } from 'react';
import {Link} from "react-router-dom";

import {FaRegCopyright, FaHeart} from 'react-icons/fa';
import '../../assets/css/footer.css'


class Footer extends Component {
    render() {
        return(
            <div className='footer footer-theme'>
                <div className='ack-text'>
                    <p className='left-text'><FaRegCopyright/> gqlX 2022</p>
                    <p className='right-text'>make with <FaHeart/>, at NFTHack</p>
                </div>

            </div>
        )
    }
}

export default Footer;